import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withStyles } from '@material-ui/styles'
import Container from '@material-ui/core/Container'
import ReportTabbar from '../components/report/ReportTabbar'


const styles = theme => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(12),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  }
})

@withStyles(styles)
@inject('NavStore')
@observer
class Report extends Component {

  componentDidMount() {
    this.props.NavStore.setActiveMenu('report')
    this.props.NavStore.setNavBarTitle('Report')
  }

  render() {

    const { classes, children } = this.props

    return (
      <Container maxWidth='xl' className={classes.container}>
        <ReportTabbar />
          {children}
      </Container>
    )
  }
}
export default Report